
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93mi8agiMQgala5pVtrSHGtPkyZRMSAsUuuAV9S3Or0q4Meta } from "/home/ops/apps/spreadIt/app/pages/library/public/[id].vue?macro=true";
import { default as impersonation_45audit5IdJXVijQJuGts4IndUITMyZThVmTQ7FFRlXSVdtDPwMeta } from "/home/ops/apps/spreadIt/app/pages/admin/impersonation-audit.vue?macro=true";
import { default as local_45logsYY6_ncnosypTfEDcYO_vyXmT2OzStu_wcl1UuROelLwMeta } from "/home/ops/apps/spreadIt/app/pages/admin/local-logs.vue?macro=true";
import { default as confirm_iqnJQzauA828IzIye53aIdrlXPT6EX3pwS72y44SK4Meta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/confirm.vue?macro=true";
import { default as forgot_45password94jFJjimGmD_FQZjez4_3XYjfygm2JUlDipY1wBj3HgMeta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/forgot-password.vue?macro=true";
import { default as registerITCyNwVUaulRzkCbrIJt_iYfPyeZms2e5CTB3ZOVm28Meta } from "/home/ops/apps/spreadIt/app/pages/auth/register.vue?macro=true";
import { default as resetpasswordeKH8mGDG0HAfgaTX6bHPuBw2BC40WhQMc6qagTMlSAYMeta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/resetpassword.vue?macro=true";
import { default as resetpassword2PjWh4ZpOrQ4MJ2p7b4td8lieINOZ_vwAabSMMfv49RMMeta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/resetpassword2.vue?macro=true";
import { default as resetpassword3aOkE_nXHEzLWM1I9ckoKmyjQCL8z_Ji3KPWXwewcE4kMeta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/resetpassword3.vue?macro=true";
import { default as signinirjxSkQ3x317a1bqRSv3O_v50mmzMG_fU87fiQOYpQUMeta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/signin.vue?macro=true";
import { default as signupfy4OtqrFHq8xpsPBQLRadq8LQgKdS7rbNF_HpzKsZzcMeta } from "/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/signup.vue?macro=true";
import { default as templateiXa6Nh_XL_GP6uOUTHCgwCP88PuVP_KHx0zYf85tlkIMeta } from "/home/ops/apps/spreadIt/app/pages/debug/template.vue?macro=true";
import { default as indexS27nrSvrRNXvXXv1f65fXCFY5_qbYF3sMaYDh4wrlk8Meta } from "/home/ops/apps/spreadIt/app/pages/library/public/index.vue?macro=true";
import { default as updatesFAWNYn1zsU0li_JpeqfqDhyoUTRe7MnwMP7sqcbvxF4Meta } from "/home/ops/apps/spreadIt/app/pages/library/updates.vue?macro=true";
import { default as indexJwcr2Q6yHyN5_ggORHZKihk4Q_s_Rh_sJh9FYT1WxgsMeta } from "/home/ops/apps/spreadIt/app/pages/settings/credentials/index.vue?macro=true";
import { default as llmHUEFtAsqwYFSQtE7ndm0YmtxVkZRGpPnyULQkVn1QeQMeta } from "/home/ops/apps/spreadIt/app/pages/settings/llm.vue?macro=true";
import { default as llm_45usage8fMVamggZ7P5kQs4j_xa2k590pHUdKWStUEvS1FSxdkMeta } from "/home/ops/apps/spreadIt/app/pages/settings/llm-usage.vue?macro=true";
import { default as sandboxb2NqkBLOEqfl3lSR86ztDxfKiOJnf90QISHx2ng9UAEMeta } from "/home/ops/apps/spreadIt/app/pages/settings/sandbox.vue?macro=true";
import { default as newL_yEA9hX5MSJXE87MZwgA642oYtg8cF7_f_chuh6wMMMeta } from "/home/ops/apps/spreadIt/app/pages/tabs/new.vue?macro=true";
import { default as newmyVcUBbeskjNXkRN0k_rMcwZvJrHE80uL0Kh9XWPpxMMeta } from "/home/ops/apps/spreadIt/app/pages/templates/new.vue?macro=true";
import { default as settingsMBU4LGxzqVIgZ7Tgcybw_sXvqHEofleklnnjH5R8_QwMeta } from "/home/ops/apps/spreadIt/app/pages/user/settings.vue?macro=true";
import { default as _91invitationId_93_46accepthzx0K6KSSSbhnX4Wd1BYX0G_vFS47R0zDN22jvcg_wcMeta } from "/home/ops/apps/spreadIt/app/pages/auth/[invitationId].accept.vue?macro=true";
import { default as _91join_password_93nkNWwm4VSYqAw8Cw58EdsKYYbeZWmgNPKvHgD6kL_mYMeta } from "/home/ops/apps/spreadIt/app/pages/join/[join_password].vue?macro=true";
import { default as _91id_93d_xIe1D9HRr7C8yMLv9fNoOSr3bG5DUvDVKjFc7GezwMeta } from "/home/ops/apps/spreadIt/app/pages/library/[id].vue?macro=true";
import { default as _91id_93pq_urEFbtdOKEPCCZ8xVrRZVtRk9O__BgqexKYQ5ZW4Meta } from "/home/ops/apps/spreadIt/app/pages/tabs/[id].vue?macro=true";
import { default as _91id_93aUpEHAkpOD23jk0mXN77O8JQdtPTBYMDNQrYFi4iSQgMeta } from "/home/ops/apps/spreadIt/app/pages/templates/[id].vue?macro=true";
import { default as _91slug_93sO6gDKrRUGcheWsJwA_GjiAUgy5SX2UkKfjWOXZEJR4Meta } from "/home/ops/apps/spreadIt/app/pages/use-cases/[slug].vue?macro=true";
import { default as accountUBWs2K1duZ2Lr766vVrSU7vyA3rv8SfwI33pDLT3BwEMeta } from "/home/ops/apps/spreadIt/app/pages/account.vue?macro=true";
import { default as billingdjZbJt07_imi7VMjXKwl6VcW61PcCQswDzEGn120df8Meta } from "/home/ops/apps/spreadIt/app/pages/billing.vue?macro=true";
import { default as cancelBwMi6_xsBqvIz8mFBmsjV_35nQ7SXUMS_Z04MKGpCDgMeta } from "/home/ops/apps/spreadIt/app/pages/cancel.vue?macro=true";
import { default as contact55OGPS8AGCpXxsdAmw_w8aEwn_BabuaO68Z8ztc5C_cMeta } from "/home/ops/apps/spreadIt/app/pages/contact.vue?macro=true";
import { default as indexypFSEco_krb6_wi_w4olaEVAd3qYHvtJRkv78g02vOQMeta } from "/home/ops/apps/spreadIt/app/pages/contexts/index.vue?macro=true";
import { default as dashboardbEj_Ic2h6B7v2vAGPM9VYWiNN6ADx8kz_HK_DTiw02sMeta } from "/home/ops/apps/spreadIt/app/pages/dashboard.vue?macro=true";
import { default as deletemyaccountjtjKiCsLRf7mKRVlObP4BqYMk67GZ8mlu7LahvTqBJAMeta } from "/home/ops/apps/spreadIt/app/pages/deletemyaccount.vue?macro=true";
import { default as fail21e__6Sg_gZCAPoKL8Bovw7cwF2I70fryXXYx_NHIqgMeta } from "/home/ops/apps/spreadIt/app/pages/fail.vue?macro=true";
import { default as indexH5G2xNN52YMO_X2bDgIKnqq2hr61hPCgNN4lLb1hjkUMeta } from "/home/ops/apps/spreadIt/app/pages/library/index.vue?macro=true";
import { default as pricingVA0Vfvw7kM3pgY6uFOlCcBp4ryPGGiWKPcYHvUUCF2MMeta } from "/home/ops/apps/spreadIt/app/pages/pricing.vue?macro=true";
import { default as privacyActsvxPhWOjSNyoa3fLPvFjP_4ZYx4dts4YV2a1YoJMMeta } from "/home/ops/apps/spreadIt/app/pages/privacy.vue?macro=true";
import { default as successcWqbQh599a0IiHpxfujdT_a2Ue_MU04dqse8Lgxyt8YMeta } from "/home/ops/apps/spreadIt/app/pages/success.vue?macro=true";
import { default as indexnaJfmQXcisWT16IjkrzzVXNEf5AMuBgB4uUPMdEwg7gMeta } from "/home/ops/apps/spreadIt/app/pages/tabs/index.vue?macro=true";
import { default as indexqaHkpKBpQ6k4csEaPGUhQvzdwyd9uIdIkCeydA4PT_4Meta } from "/home/ops/apps/spreadIt/app/pages/templates/index.vue?macro=true";
import { default as termsl7as7LVV0qrfJx0YFtACXovjItiMZUWweDEENlRRUO8Meta } from "/home/ops/apps/spreadIt/app/pages/terms.vue?macro=true";
import { default as indexIXE1jsMZjQWRRMCfiAfAFble1FwXYE1_0_rrriH6AjwMeta } from "/home/ops/apps/spreadIt/app/pages/use-cases/index.vue?macro=true";
import { default as indexTd19oM46QYqF7ZwK7bGm_q_JGM6ekX_T3ehS5iUH30MMeta } from "/home/ops/apps/spreadIt/app/pages/index.vue?macro=true";
export default [
  {
    name: "library-public-id",
    path: "/library/public/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/library/public/[id].vue")
  },
  {
    name: "admin-impersonation-audit",
    path: "/admin/impersonation-audit",
    meta: impersonation_45audit5IdJXVijQJuGts4IndUITMyZThVmTQ7FFRlXSVdtDPwMeta || {},
    component: () => import("/home/ops/apps/spreadIt/app/pages/admin/impersonation-audit.vue")
  },
  {
    name: "admin-local-logs",
    path: "/admin/local-logs",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/admin/local-logs.vue")
  },
  {
    name: "auth-confirm",
    path: "/auth/confirm",
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/confirm.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerITCyNwVUaulRzkCbrIJt_iYfPyeZms2e5CTB3ZOVm28Meta || {},
    component: () => import("/home/ops/apps/spreadIt/app/pages/auth/register.vue")
  },
  {
    name: "auth-resetpassword",
    path: "/auth/resetpassword",
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/resetpassword.vue")
  },
  {
    name: "auth-resetpassword2",
    path: "/auth/resetpassword2",
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/resetpassword2.vue")
  },
  {
    name: "auth-resetpassword3",
    path: "/auth/resetpassword3",
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/resetpassword3.vue")
  },
  {
    name: "auth-signin",
    path: "/auth/signin",
    meta: signinirjxSkQ3x317a1bqRSv3O_v50mmzMG_fU87fiQOYpQUMeta || {},
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/signin.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/home/ops/apps/spreadIt/layers/auth-zitadel/pages/auth/signup.vue")
  },
  {
    name: "debug-template",
    path: "/debug/template",
    meta: { ...(templateiXa6Nh_XL_GP6uOUTHCgwCP88PuVP_KHx0zYf85tlkIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ops/apps/spreadIt/app/pages/debug/template.vue")
  },
  {
    name: "library-public",
    path: "/library/public",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/library/public/index.vue")
  },
  {
    name: "library-updates",
    path: "/library/updates",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/library/updates.vue")
  },
  {
    name: "settings-credentials",
    path: "/settings/credentials",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/settings/credentials/index.vue")
  },
  {
    name: "settings-llm",
    path: "/settings/llm",
    meta: { ...(llmHUEFtAsqwYFSQtE7ndm0YmtxVkZRGpPnyULQkVn1QeQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ops/apps/spreadIt/app/pages/settings/llm.vue")
  },
  {
    name: "settings-llm-usage",
    path: "/settings/llm-usage",
    meta: { ...(llm_45usage8fMVamggZ7P5kQs4j_xa2k590pHUdKWStUEvS1FSxdkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ops/apps/spreadIt/app/pages/settings/llm-usage.vue")
  },
  {
    name: "settings-sandbox",
    path: "/settings/sandbox",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/settings/sandbox.vue")
  },
  {
    name: "tabs-new",
    path: "/tabs/new",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/tabs/new.vue")
  },
  {
    name: "templates-new",
    path: "/templates/new",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/templates/new.vue")
  },
  {
    name: "user-settings",
    path: "/user/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/ops/apps/spreadIt/app/pages/user/settings.vue")
  },
  {
    name: "auth-invitationId.accept",
    path: "/auth/:invitationId().accept",
    component: () => import("/home/ops/apps/spreadIt/app/pages/auth/[invitationId].accept.vue")
  },
  {
    name: "join-join_password",
    path: "/join/:join_password()",
    component: () => import("/home/ops/apps/spreadIt/app/pages/join/[join_password].vue")
  },
  {
    name: "library-id",
    path: "/library/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/library/[id].vue")
  },
  {
    name: "tabs-id",
    path: "/tabs/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/tabs/[id].vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/templates/[id].vue")
  },
  {
    name: "use-cases-slug",
    path: "/use-cases/:slug()",
    component: () => import("/home/ops/apps/spreadIt/app/pages/use-cases/[slug].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/account.vue")
  },
  {
    name: "billing",
    path: "/billing",
    component: () => import("/home/ops/apps/spreadIt/app/pages/billing.vue")
  },
  {
    name: "cancel",
    path: "/cancel",
    meta: cancelBwMi6_xsBqvIz8mFBmsjV_35nQ7SXUMS_Z04MKGpCDgMeta || {},
    component: () => import("/home/ops/apps/spreadIt/app/pages/cancel.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/ops/apps/spreadIt/app/pages/contact.vue")
  },
  {
    name: "contexts",
    path: "/contexts",
    meta: { ...(indexypFSEco_krb6_wi_w4olaEVAd3qYHvtJRkv78g02vOQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/ops/apps/spreadIt/app/pages/contexts/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/dashboard.vue")
  },
  {
    name: "deletemyaccount",
    path: "/deletemyaccount",
    component: () => import("/home/ops/apps/spreadIt/app/pages/deletemyaccount.vue")
  },
  {
    name: "fail",
    path: "/fail",
    meta: fail21e__6Sg_gZCAPoKL8Bovw7cwF2I70fryXXYx_NHIqgMeta || {},
    component: () => import("/home/ops/apps/spreadIt/app/pages/fail.vue")
  },
  {
    name: "library",
    path: "/library",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/library/index.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/home/ops/apps/spreadIt/app/pages/pricing.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/ops/apps/spreadIt/app/pages/privacy.vue")
  },
  {
    name: "success",
    path: "/success",
    meta: successcWqbQh599a0IiHpxfujdT_a2Ue_MU04dqse8Lgxyt8YMeta || {},
    component: () => import("/home/ops/apps/spreadIt/app/pages/success.vue")
  },
  {
    name: "tabs",
    path: "/tabs",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/tabs/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: {"middleware":["auth"]},
    component: () => import("/home/ops/apps/spreadIt/app/pages/templates/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/ops/apps/spreadIt/app/pages/terms.vue")
  },
  {
    name: "use-cases",
    path: "/use-cases",
    component: () => import("/home/ops/apps/spreadIt/app/pages/use-cases/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ops/apps/spreadIt/app/pages/index.vue")
  }
]